import { render, staticRenderFns } from "./option-modal-rename.vue?vue&type=template&id=2da59d38&"
import script from "./option-modal-rename.vue?vue&type=script&lang=js&"
export * from "./option-modal-rename.vue?vue&type=script&lang=js&"
import style0 from "./option-modal-rename.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports